import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { EditConditionalField } from "@/modules/FormTemplate/models/EditConditionalField";
import { Field } from "@/modules/FormTemplate/models/Field";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";

Vue.use(Vuetify);

@Component({
  name: "ConditionalFieldComponent",
  components: {
    EmptyState,
    ModifVJsfInput
  }
})
export default class ConditionalFieldComponent extends Vue {
  @Prop() private conditionIndex!: number;
  @Prop() private fields!: Field[];

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  FIELD_EMPTY_STATE_HEADER = FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_HEADER;
  FIELD_EMPTY_STATE_PARAGRAPH =
    FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_PARAGRAPH;

  EDIT_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_CONDITIONAL_COMPONENT_TOOLTIPS.BTN_TOOLTIPS
      .EDIT_FIELD;
  DELETE_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_CONDITIONAL_COMPONENT_TOOLTIPS.BTN_TOOLTIPS
      .DELETE_FIELD;
  model = {};

  editConditionalField(index: number) {
    const data: EditConditionalField = {
      conditionIndex: this.conditionIndex,
      fieldIndex: index
    };

    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.EDIT,
      data
    );
  }

  deleteConditionalField(index: number) {
    const data: EditConditionalField = {
      conditionIndex: this.conditionIndex,
      fieldIndex: index
    };

    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.DELETE,
      data
    );
  }

  saveConditionalFieldOrder() {
    this.$emit(
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY,
      FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.SAVE_NEW_ORDER,
      this.conditionIndex
    );
  }

  getSchema(index: number) {
    const schema = {
      type: "object",
      properties: {
        field: {}
      }
    };

    schema.properties.field = this.fields[index].schema;
    return schema;
  }
}
